/**
 * Created by spepa on 04.07.2024
 */

const LazyAsset = cc.Node.extend({
    ctor: function (res, options) {
        options = options || {};

        this.options = options;
        this.asset = undefined;
        this.virtualResource = res.resolve();
        this._pendingCalls = [];

        this._super();
        this.setAnchorPoint(0.5, 0.5);

        const dimensions = this.virtualResource.getDimensions();
        if (dimensions) {
            this.setContentSize2(dimensions);
        } else {
            cleverapps.throwAsync(`Empty dimensions for lazy asset ${this.virtualResource} ${res}`);
        }

        this.createPreview();

        if (cleverapps.gameModes.stopLazyLoading) {
            return;
        }

        if (cleverapps.lazyAssets.isLoaded(this.virtualResource) || cleverapps.lazyAssets.isPreferredBundle(this.virtualResource.getBundleName())) {
            this.loaded = true;

            cleverapps.lazyAssets.loadResource(this.virtualResource, this.createListener(this.createAsset.bind(this)));

            if (this.options.keepLazy) {
                cleverapps.lazyAssets.keepResource(this.virtualResource);
            }
        } else {
            cleverapps.throwAsync(`Image is not allowed to be load ${this.virtualResource} ${res}`);
        }
    },

    cleanup: function () {
        this._super();

        if (this.loaded) {
            this.loaded = false;

            cleverapps.lazyAssets.deleteResource(this.virtualResource);
        }
    },

    whenAssetLoaded: function (callback) {
        if (this.asset) {
            callback();
        } else {
            this._pendingCalls.push(callback);
        }
    },

    isSpine: function () {
        return this.virtualResource instanceof VirtualJson;
    },

    createPreview: function () {
        this.preview = this.options.preview || new cc.Sprite(bundles.merge.frames.unit_unknown);
        this.preview.setPosition(this.width / 2, this.height / 2);
        this.addChild(this.preview);

        this.preview.setVisible(false);
        this.preview.runAction(new cc.Sequence(
            new cc.DelayTime(0.2),
            new cc.Show()
        ));
    },

    createAsset: function () {
        if (this.asset) {
            return;
        }

        if (this.virtualResource instanceof SpriteFrame) {
            this.asset = new cc.Sprite(this.virtualResource);
        } else {
            this.asset = new cleverapps.Spine(this.virtualResource);
        }
        this.asset.setPosition(this.width / 2, this.height / 2);
        this.addChild(this.asset);

        if (this.preview) {
            if (this.preview.isDisplayed()) {
                this.hidePreview(this.preview);

                this.asset.setOpacity(0);
                this.asset.runAction(new cc.FadeIn(0.5));
            } else {
                this.preview.removeFromParent();
            }
            this.preview = undefined;
        }

        this.options.onLoad && this.options.onLoad();
        this._callPending();
    },

    hidePreview: function (preview) {
        if (preview instanceof cleverapps.Spine && preview.hasAnimation("open")) {
            preview.setLocalZOrder(1);
            preview.setAnimation(0, "open", false);
            preview.setCompleteListenerRemove();
            return;
        }

        preview.runAction(new cc.Sequence(
            StandartAnimations.disappear(preview, { dust: true }),
            new cc.RemoveSelf()
        ));
    },

    _callPending: function () {
        let running = true;
        this.addCleaner(() => {
            running = false;
        });

        for (let i = 0; i < this._pendingCalls.length; i++) {
            if (!running) {
                break;
            }
            const call = this._pendingCalls[i];
            if (typeof call === "function") {
                call();
            } else {
                this.asset[call.method] && this.asset[call.method].call(this.asset, ...call.args);
            }
        }
    },

    getAnimationData: function (...rest) {
        return this.asset && this.asset.getAnimationData ? this.asset.getAnimationData.call(this.asset, ...rest) : undefined;
    },

    getAnimationDuration: function (...rest) {
        return this.asset && this.asset.getAnimationDuration ? this.asset.getAnimationDuration.call(this.asset, ...rest) : 0;
    },

    getTimeLeft: function (...rest) {
        return this.asset && this.asset.getTimeLeft ? this.asset.getTimeLeft.call(this.asset, ...rest) : 0;
    },

    isSaveToRemove: function (...rest) {
        return this.asset && this.asset.isSaveToRemove ? this.asset.isSaveToRemove.call(this.asset, ...rest) : true;
    },

    getTimeScale: function (...rest) {
        return this.asset && this.asset.getTimeScale ? this.asset.getTimeScale.call(this.asset, ...rest) : 1;
    },

    hasAnimation: function (...rest) {
        if (!this.isSpine()) {
            return false;
        }
        if (!this.asset) {
            cleverapps.throwAsync(`using hasAnimation while resource not loaded ${this.virtualResource}`);
            return false;
        }
        return this.asset.hasAnimation.call(this.asset, ...rest);
    },

    setCompleteListener: function (callback) {
        if (this.asset && this.asset.setCompleteListener) {
            this.asset.setCompleteListener(callback);
        } else {
            callback && callback();
        }
    },

    setCompleteListenerRemove: function (callback) {
        if (this.asset && this.asset.setCompleteListenerRemove) {
            this.asset.setCompleteListenerRemove(callback);
        } else {
            callback && callback();
            this.removeFromParent();
        }
    },

    setCompleteListenerOnce: function (callback) {
        if (this.asset && this.asset.setCompleteListenerOnce) {
            this.asset.setCompleteListenerOnce(callback);
        } else {
            callback && callback();
        }
    },

    _processMethodCall: function (method, ...args) {
        if (this.asset) {
            this.asset[method] && this.asset[method].call(this.asset, ...args);
        } else {
            this._pendingCalls.push({ method, args });
        }
    },

    setIdle: function (...args) {
        this._processMethodCall("setIdle", ...args);
    },

    setIdleSet: function (...args) {
        this._processMethodCall("setIdleSet", ...args);
    },

    setAnimation: function (...args) {
        this._processMethodCall("setAnimation", ...args);
    },

    addAnimation: function (...args) {
        this._processMethodCall("addAnimation", ...args);
    },

    setTimeScale: function (...args) {
        this._processMethodCall("setTimeScale", ...args);
    },

    clearTrack: function (...args) {
        this._processMethodCall("clearTrack", ...args);
    },

    setAnimationFrame: function (...args) {
        this._processMethodCall("setAnimationFrame", ...args);
    },

    setSkin: function (...args) {
        this._processMethodCall("setSkin", ...args);
    },

    setAnimationAndIdleAfter: function (...args) {
        this._processMethodCall("setAnimationAndIdleAfter", ...args);
    },

    setSafeToRemove: function (...args) {
        this._processMethodCall("setSafeToRemove", ...args);
    },

    isLoaded: function () {
        return Boolean(this.asset);
    }
});